import { styled } from "@mui/material";

import { CatalystIcon as UnstyledCatalystIcon } from "@citrine/atoms/icons";

export const Container = styled("div")(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(3),
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  rowGap: theme.spacing(2),
  textAlign: "center",
  alignItems: "center",
}));

export const CatalystIcon = styled(UnstyledCatalystIcon)(({ theme }) => ({
  fontSize: theme.spacing(12),
}));
